import { Injectable, signal } from '@angular/core'
import { FollowupRequestDto, HistoryMessageDto } from '@core/services/tracking-research.service'

export type DetailModalItem = FollowupRequestDto | HistoryMessageDto

@Injectable({ providedIn: 'root' })
export class FollowupDetailModalService {
  readonly item = signal<DetailModalItem | null>(null)

  show(item: DetailModalItem): void {
    this.item.set(item)
  }

  hide(): void {
    this.item.set(null)
  }
}
